import lodashOrderBy from "lodash/orderBy";
import lodashRemove from "lodash/remove";

import { encodeAllURLParameters } from "@/common/api.utilities";
import { ENDPOINT_WOD_CHARTS } from "@/common/constants/api";
import { httpGet } from "@/services/api.service";
import { getDifference } from "@/common/date.utilities";

export { getChartData };

/**
 * Gets the chart data for the query defined by `params`
 * @param params {Object} Defines the query parameters for the request to /wod/charts
 * @returns {chartData}
 */
const getChartData = async (params) => {
  //Add the timeBinSize parameter based on the start and end date
  if (params.start && params.end) {
    const numDaysRange = getDifference(params.start, params.end);

    if (typeof numDaysRange === "number" && numDaysRange > 365) {
      params.timeBinSize = "1M";
    }
  }

  const endpoint = encodeAllURLParameters({
    baseEndpoint: ENDPOINT_WOD_CHARTS,
    params: params,
  });
  const result = JSON.parse(
    await httpGet({
      url: endpoint,
    })
  ).data;

  return formatChartData(result).charts;
};

/**
 * Reformats the chart API response in any way needed for the UI
 * @param data {Object} The response from ES
 * @returns {Object}
 */
const formatChartData = (data) => {
  if (!data?.charts) {
    return {};
  }

  //Use capitalized versions of the series names
  if (data.charts.emotionsByDate) {
    data.charts.emotionsByDate.seriesData.forEach((s) => {
      s.name = s.name.charAt(0).toUpperCase() + s.name.substring(1);
    });
  }

  // Order the series so it's always in this order to make sure the
  // colors are always consistent, but first remove the Total object
  // so we can always put that at the start
  if (data.charts.topicsByDate) {
    let series = data.charts.topicsByDate.seriesData;
    const totalArr = lodashRemove(series, (s) => {
      return s.name.toUpperCase() === "TOTAL";
    });
    const total =
      Array.isArray(totalArr) && totalArr.length === 1 ? totalArr[0] : null;
    series = lodashOrderBy(series, ["name"]);
    if (total) {
      series.unshift(total);
    }
    data.charts.topicsByDate.seriesData = series;
  }

  if (data.charts.sentimentHistogram) {
    data.charts.sentimentHistogram = data.charts.sentimentHistogram.buckets;
  }

  return data;
};
